import { z } from "zod";
import {
  AP_INVOICE,
  BLANKET_LIMIT,
  BOARD_LEVEL_APPROVAL,
  BUDGET,
  CONTRACT,
  PM_APPROVAL_LIMIT,
  PM_YEARLY_LIMIT,
  SINGLE_APPROVAL,
  WORK_ORDER,
} from "./consts";

export const schema = z.object({
  [AP_INVOICE]: z
    .string()
    .min(1, "This Field is required")
    .transform((val) => Number(val))
    .refine((val) => val > 0, {
      message: "value must be greater than 0",
    }),
  [BUDGET]: z
    .string()
    .min(1, "This Field is required")
    .transform((val) => Number(val))
    .refine((val) => val > 0, {
      message: "value must be greater than 0",
    }),
  [CONTRACT]: z
    .string()
    .min(1, "This Field is required")
    .transform((val) => Number(val))
    .refine((val) => val > 0, {
      message: "value must be greater than 0",
    }),
  [WORK_ORDER]: z
    .string()
    .min(1, "This Field is required")
    .transform((val) => Number(val))
    .refine((val) => val > 0, {
      message: "value must be greater than 0",
    }),
  [BLANKET_LIMIT]: z
    .string()
    .min(1, "This Field is required")
    .transform((val) => Number(val))
    .refine((val) => val > 0, {
      message: "value must be greater than 0",
    }),
  [SINGLE_APPROVAL]: z
    .string()
    .min(1, "This Field is required")
    .transform((val) => Number(val))
    .refine((val) => val > 0, {
      message: "value must be greater than 0",
    }),
  [BOARD_LEVEL_APPROVAL]: z
    .string()
    .min(1, "This Field is required")
    .transform((val) => Number(val))
    .refine((val) => val > 0, {
      message: "value must be greater than 0",
    }),
  [PM_APPROVAL_LIMIT]: z
    .string()
    .min(1, "This Field is required")
    .transform((val) => Number(val))
    .refine((val) => val > 0, {
      message: "value must be greater than 0",
    }),
  [PM_YEARLY_LIMIT]: z
    .string()
    .min(1, "This Field is required")
    .transform((val) => Number(val))
    .refine((val) => val > 0, {
      message: "value must be greater than 0",
    }),
});

export type formValues = z.infer<typeof schema>;
